
export const GRANT_TYPE = 'client_credentials'
export const CLIENT_ID = 'hia-platform-ui'
export const CLIENT_SECRET = 'secret'
